const interviews = {
    2025: [
        "https://youtu.be/k0JOiOPrxqM",
        "https://youtu.be/VTMI-hJa2jA",
        "https://youtu.be/pEE-UPhf93g",
        "https://youtu.be/wO0q5ChzBK8",
        "https://youtu.be/utZyrhB8Q-Y",
        "https://youtu.be/0r9AsODYzlI",
        "https://youtu.be/T3H6uxZWOjo",
        "https://youtu.be/kCpI7HIu5nc",
        "https://youtu.be/GogTe4pIsbU",
        "https://youtu.be/VMF78d6jrmk",
        "https://youtu.be/RsG6Sspfq9o",
        "https://youtu.be/XTxTXTw6anU",
        "https://youtu.be/Zr8Y0OGC7JU",
        "https://youtu.be/yZ_CvhYSZLQ",
        "https://youtu.be/z3uC4rp84_w",
        "https://youtu.be/d1rbMQDT_II",
        "https://youtu.be/JTalpsbKo8E",
        "https://youtu.be/qcdSZlhbTQk",
        "https://youtu.be/Ysr-aWqFiZg",
        "https://youtu.be/rMNlFQkWhD4",
        "https://youtu.be/g6u21bapBC4",
        "https://youtu.be/55OlDhS1nL8",
        "https://youtu.be/KLRuOFsBuNU",
        "https://youtu.be/nsQp4KQ-okg",
        "https://youtu.be/Pt56kzhMRbw",
        "https://youtu.be/wbsO6YBB3OE",
        "https://youtu.be/fjdYcmFSjqk",
        "https://youtu.be/BsSyZZi-fDE",
        "https://youtu.be/hQ6_6vWQfwY",
        "https://youtu.be/ltcGzaG9_C8",
        "https://youtu.be/bAvAG7-nH04",
        "https://youtu.be/qN6OYsRztuk",
        "https://youtu.be/GIfoU67n0xA",
        "https://youtu.be/0V6op1Y1IjY",
        "https://youtu.be/XmtwYqO8wAc",
        "https://youtu.be/lmwl21K_PsA",
    ],
    2024: [
        "https://youtu.be/2MFjcupIZ5o",
        "https://youtu.be/DtZgcQnCWpo",
        "https://youtu.be/xa6W5WMSGR0",
        "https://youtu.be/nmWF5hVQ-Qs",
        "https://youtu.be/3nqWNEFc2qc",
        "https://youtu.be/90ImAc9Y7y8",
        "https://youtu.be/G4NgNHWytIo",
        "https://youtu.be/6yW1wwGx0v0",
        "https://youtu.be/pMpm0esXKWo",
        "https://youtu.be/kGGI6N00EJQ",
        "https://youtu.be/wYa_2ZjElEg",
        "https://youtu.be/wJtKdjLG7p8",
        "https://youtu.be/euIvpcx9Pms",
        "https://youtu.be/Zqla9sb5n3w",
        "https://youtu.be/tP2SreKH-8I",
        "https://youtu.be/OgvIsrRlxD8",
        "https://youtu.be/2QHsxWJQ3lM",
        "https://youtu.be/GDeKuZGUnJw",
        "https://youtu.be/svMB5Q1m9xc",
        "https://youtu.be/fXba2zWLBXY",
        "https://youtu.be/pMpm0esXKWo",
        "https://youtu.be/fssuhPja1IQ",
        "https://youtu.be/Q8VRdDVrkG4",
        "https://youtu.be/Ly1SSe_j6Q8",
        "https://youtu.be/ui7WBj-rXOw",
        "https://youtu.be/Qlun7_M00sA",
        "https://youtu.be/urzvXy-GbEg",
        "https://youtu.be/2K3BBqphNLM",
        "https://youtu.be/k9D2ljiY-tw",
        "https://youtu.be/q0iv9U87KE4",
        "https://youtu.be/-e26JpktzBQ",
        "https://youtu.be/BraJ-sG-MNs",
        "https://youtu.be/103yE30GRGA",
    ],
     2023: [
        "https://youtu.be/EJU6AYevXw0",
        "https://youtu.be/lPAKjYLz1s4",
        "https://youtu.be/9eROJkdIxTw",
        "https://youtu.be/r5tohwWU9rw",
        "https://youtu.be/xKpu56yQfuY",
        "https://youtu.be/v9SHpjbtBSo",
        "https://youtu.be/ESl6bBEKtto",
        "https://youtu.be/LKJiSYSuIVk",
        "https://youtu.be/62LHohwwL1s",
        "https://youtu.be/-h5Tbhu_fBI",
        "https://youtu.be/0_IgIfzeaHY",
        "https://youtu.be/fq7b7l9TljU",
        "https://youtu.be/3ZWsmd_wRT0",
        "https://youtu.be/GwZOhWWh6-Y",
        "https://youtu.be/ZFdrUxEKDZA",
        "https://youtu.be/1k5CuAOeT04",
        "https://youtu.be/XumYkpuUmy4",
        "https://youtu.be/2MFjcupIZ5o",
        "https://youtu.be/nmWF5hVQ-Qs",
        "https://youtu.be/95gU6q_ALB8",
        "https://youtu.be/dZV0lkEbl2g",
        "https://youtu.be/PKEriGgL8KE",
        "https://youtu.be/vNtOckrDPl8",
        "https://youtu.be/_6DYSq2HaZg",

    ],
     2022: [
        "https://youtu.be/Cthc37MXWkI",
        "https://youtu.be/0OKH6xcoJ-I",
        "https://youtu.be/Ukz8--9Mic0",
        "https://youtu.be/y8h9np1-7eE",
        "https://youtu.be/Oj99tqrV2-k",
        "https://youtu.be/MkDL2OKdhWg",
        "https://youtu.be/pVmfONOLqF8",
        "https://youtu.be/_pPXnFX6PVQ",
        "https://youtu.be/nzFRmy-wW24",
        "https://youtu.be/gO-00qSIQGg",
        "https://youtu.be/1b-tHRVGdyM",
        "https://youtu.be/w4fCjdfzruk",
        "https://youtu.be/LIJijLPo3ZE",
        "https://youtu.be/LanVVIdSJQ0",
        "https://youtu.be/1J93L6vttkE",
        "https://youtu.be/rlr9_uQciFA",
        "https://youtu.be/yVQx_uzaG60",
        "https://youtu.be/f2Z_LZpdrks",

    ],
    2021: [
        "https://youtu.be/DlFon4cAGOE",
        "https://youtu.be/Dmiw8tgk8Ic",
        "https://youtu.be/H1j5QJya2nk",
        "https://youtu.be/pTgoCKw-l5w",
        "https://youtu.be/oNXvcW6dpwg",
        "https://youtu.be/9mLIbQgdLdo",
        "https://youtu.be/ryXmJ1_V2Wc",
        "https://youtu.be/PHnyHD_xKds",
        "https://youtu.be/M9_L3sxyLN0",
        "https://youtu.be/5KaDNnnpmAk",
        "https://youtu.be/40LTFopOrFU",
        "https://youtu.be/zntRnxASSnc",
        "https://youtu.be/Jz370VwbtYY",
        "https://youtu.be/FcmjT5LGwt8",
        "https://youtu.be/OpvJFzeH144",
        "https://youtu.be/mR8nIDaCF4I",
        "https://youtu.be/g923kH3M2Xs",
        "https://youtu.be/sudoMlgykwU",
        "https://youtu.be/BlOPrp1_r5s",
        "https://youtu.be/khfOb7_b_kA",
        "https://youtu.be/O4yy4DFlziQ",
        "https://youtu.be/UkFRobknpg4",
        "https://youtu.be/UkFRobknpg4",
        "https://youtu.be/TeIuigHrdYA",
        "https://youtu.be/v6ymSKaIDBc",
        "https://youtu.be/SIRzp3avcX8",
        "https://youtu.be/_KgEszfPLn4",
        "https://youtu.be/_zkIdmukcF0",
        "https://youtu.be/TEtviLDGFYo",
        "https://youtu.be/BZAb4axTrgg",

    ],
     2020: [
        "https://youtu.be/nHBdKm6R_TU",
        "https://youtu.be/Iqnv3m2JYvU",
        "https://youtu.be/HEpna0Hzrbs",
        "https://youtu.be/-ROMmirkEcY",
        "https://youtu.be/UD6l66y39J0",
        "https://youtu.be/H-nRcMgSZ_E",
        "https://youtu.be/xwdBgSq2WFo",
        "https://youtu.be/-FjH_VIk9So",
        "https://youtu.be/Egy_XdedgFk",
        "https://youtu.be/BRuW4HJaFSo",
        "https://youtu.be/2gkGZDFLoZQ",
        "https://youtu.be/hwAr-SbzVSE",
        "https://youtu.be/RyBu0G9vLeo",
        "https://youtu.be/4cs4mz0CFUw",
        "https://youtu.be/Rd4EI1SVG4I",
        "https://youtu.be/xlf6Y6mV05s",
        "https://youtu.be/458OiJULXQo",
        "https://youtu.be/3SpgiQM1nq8",
    ],
    2019: [
        "https://youtu.be/NLlrNbDtk90",
        "https://youtu.be/1X0plC0Umuc",
        "https://youtu.be/CS1s4NXxLrI",
        "https://youtu.be/MGz2UjnwS3o",
        "https://youtu.be/uVpj4G2SHao",
        "https://youtu.be/zaTT_HN1ejM",
        "https://youtu.be/z22nbeF-Iig",
        "https://youtu.be/XHUi-jqI8gQ",
        "https://youtu.be/BcYYGfJDNec",
        "https://youtu.be/dQbWY7lFXiM",
        "https://youtu.be/dJI6nRypRfg",
        "https://youtu.be/E7dTu9_Jmgk",
        "https://youtu.be/gdSV-5v4J_I",
        "https://youtu.be/QIrUMH65PEY",
        "https://youtu.be/0Q7DYiOLHlA",
        "https://youtu.be/f5k2OS8KM4g",
        "https://youtu.be/NfkGCWQ3vH8",
        "https://youtu.be/MfFOOQXVOcc",
        "https://youtu.be/1xOHjhpF5qU",
        "https://youtu.be/B77zHbLz4bg",
        "https://youtu.be/mBCVJGa0f6g",
        "https://youtu.be/-ZeKNWufNwI",
        "https://youtu.be/-ZeKNWufNwI",
        "https://youtu.be/-ZeKNWufNwI",
        "https://youtu.be/UuXNQY_yJlQ",
    ],
    2018: [
        "https://youtu.be/aBbs56zqvUE",
        "https://youtu.be/-Vr8UdNY8nw",
        "https://youtu.be/ri25M91OC0g",
        "https://youtu.be/ejPKDyophKs",
        "https://youtu.be/Dt_euoegu9A",
        "https://youtu.be/kynn28JGszU",
    ],
    2017: [
        "https://youtu.be/ANDIZJ8uc64",
        "https://youtu.be/jwmlWS96Zws",
    ],
    2016: [
        "https://youtu.be/wDIyv0TW_rQ",
        "https://youtu.be/JLiw3roPg-I",
        "https://youtu.be/wW1nkLVb9J0",
        "https://youtu.be/VHEc__MvGLQ",
        "https://youtu.be/gKqfKaVe2wM",
        "https://youtu.be/4Ra8k74UupI",
        "https://youtu.be/IoMYD-n92eQ",
        "https://youtu.be/5wV-ylDqlmE",
    ],
};

export default interviews;